import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { PREMIUMCOLUMNS, PREMIUMCOLUMNS1 } from './../utils';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  props: {
    list: {
      type: Array,
      require: true,
      default: () => []
    },
    name: {
      type: String,
      require: true,
      default: ''
    },
    isEdit: {
      type: Boolean,
      require: false,
      default: false
    },
    price: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    structureList2: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      PREMIUMCOLUMNS,
      PREMIUMCOLUMNS1,
      tableData: [],
      itemObj: {
        discountMode: undefined,
        discountRatio: '',
        discountAmount: '',
        price: '',
        structureIds: []
      },
      treeData: [],
      tableDataNum: -1,
      structureList: [],
      structureListNew: []
    };
  },
  mounted() {
    this.tableData = recursionCopy(this.list);
    this.structureListNew = recursionCopy(this.structureList2);
    if (this.tableData.length === 0) {
      this.structureListNew = this.traverseTree3(this.structureListNew);
    }
    let arr = [];
    this.tableData.map(item => {
      arr = arr.concat(item.structureIds);
    });
    const num = arr.find(item => item == 0);
    if (num) {
      arr = [0];
    }
    console.log(this.index, arr);
    if (arr[0] == 0) {
      this.structureListNew = this.traverseTree2(this.structureListNew);
    } else {
      this.structureListNew = this.traverseTree(this.structureListNew, arr);
      this.structureListNew[0].disabled = arr.length > 0 ? true : false;
    }
    this.structureList = recursionCopy(this.structureListNew);
  },
  methods: {
    handleAdd() {
      this.itemObj.id = this.tableData.length + 1;
      this.tableDataNum = -1;
      if (this.tableData.length == 0) {
        this.tableData.push(recursionCopy(this.itemObj));
      } else {
        const obj = recursionCopy(this.tableData[this.tableData.length - 1]);
        const num = obj.discountRatio || obj.discountAmount;
        if (!obj.discountMode || obj.structureIds.length == 0 || !num) {
          this.tableDataNum = this.tableData.length - 1;
          this.$message.error(this.$t('配置完成才可以添加'));
        } else if (Number(obj.price || 0) <= 0) {
          this.tableDataNum = this.tableData.length - 1;
          this.$message.error(this.$t('需要把第') + Number(this.tableData.length) + this.$t('行配置修改完成,才可以保存'));
        } else {
          this.tableData.push(recursionCopy(this.itemObj));
        }
      }
    },
    filterTreeOption(input, treeNode) {
      return treeNode.data.props.title.includes(input);
    },
    discountModeChange(index) {
      if (index == this.tableDataNum) {
        this.tableDataNum = -1;
      }
      this.tableData[index].discountAmount = '';
      this.tableData[index].discountRatio = '';
      this.tableData[index].price = '';
    },
    priceChange(index) {
      setTimeout(() => {
        if (index == this.tableDataNum) {
          this.tableDataNum = -1;
        }
        console.log(index, this.tableDataNum);
        const num = this.tableData[index].discountMode == 'ratio' ? this.tableData[index].discountRatio : this.tableData[index].discountAmount;
        if (num <= 0) {
          this.tableData[index].price = '';
          return this.$message.error(this.$t('必须输入大于0的数字'));
        }
        if (this.tableData[index].discountMode == 'ratio') {
          if (num >= 100) {
            this.tableData[index].price = '';
            return this.$message.error(this.$t('折扣比例必须小于100的数字'));
          }
          this.tableData[index].price = Number(Number(this.price) * 100 - Number(this.price) * 100 * Number(this.tableData[index].discountRatio / 100)) / 100;
          let _indexOf = this.tableData[index].price.toString().indexOf('.');
          if (_indexOf > -1) {
            this.tableData[index].price = Number(this.tableData[index].price.toString().substr(0, _indexOf + 3));
          }
        } else {
          if (num >= Number(this.price)) {
            this.tableData[index].price = '';
            return this.$message.error(this.$t('折扣金额必须小于') + this.price + this.$t('的数字'));
          }
          let discountAmount = Number(Math.round(this.tableData[index].discountAmount * 100));
          let amountIndex = discountAmount.toString().indexOf('.');
          if (amountIndex > -1) {
            discountAmount = Number(discountAmount.toString().substr(0, amountIndex));
          }
          this.tableData[index].price = Number(Number(this.price) * 100 - Number(discountAmount)) / 100;
          let _indexOf = this.tableData[index].price.toString().indexOf('.');
          if (_indexOf > -1) {
            this.tableData[index].price = Number(this.tableData[index].price.toString().substr(0, _indexOf + 3));
          }
        }
      }, 100);
    },
    handleDel(index) {
      // this.tableDataNum = -1;
      this.tableData.splice(index, 1);
      this.treeChange(index);
    },
    treeChange(index) {
      this.tableDataNum = -1;
      let arr = [];
      console.log(this.tableData);
      this.tableData.map(item => {
        if (item.structureIds.length > 0) {
          arr = arr.concat(item.structureIds);
        }
      });
      const num = arr.find(item => item == 0);
      if (num) {
        arr = [0];
      }
      console.log(this.index, arr);
      if (arr[0] == 0) {
        this.structureList = this.traverseTree2(this.structureList);
      } else {
        this.structureList = recursionCopy(this.traverseTree(this.structureList, arr));
        this.structureList[0].disabled = arr.length > 0 ? true : false;
        console.log(this.structureList, 111);
      }
    },
    cancelFun() {
      this.tableData = recursionCopy(this.list);
      this.structureList = recursionCopy(this.structureListNew);
      this.$emit('cancel', this.index);
    },
    onEdit(index) {
      this.structureList = recursionCopy(this.structureListNew);
      this.$emit('edit', index);
    },
    onSubmit() {
      this.tableDataNum = -1;
      if (this.tableData.length > 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          const obj = recursionCopy(this.tableData[i]);
          console.log(obj, 222);
          const num = obj.discountRatio || obj.discountAmount;
          console.log(!obj.discountMode || obj.structureIds.length == 0 || !num, obj.price != '' || obj.price < 0);
          if (!obj.discountMode || obj.structureIds.length == 0 || !num) {
            this.tableDataNum = i;
            this.$message.error(this.$t('需要把第') + Number(i + 1) + this.$t('行配置完成,才可以保存'));
            break;
          } else if (Number(obj.price || 0) <= 0) {
            this.tableDataNum = i;
            this.$message.error(this.$t('需要把第') + Number(i + 1) + this.$t('行配置修改完成,才可以保存'));
            break;
          }
        }
      }
      if (this.tableDataNum != -1) {
        return false;
      }
      this.structureListNew = recursionCopy(this.structureList);
      this.$emit('save', this.index, this.tableData, this.structureList);
    },
    tableRowClass(record, index) {
      if (index == this.tableDataNum) {
        return 'rowClass';
      }
      return '';
    },
    traverseTree(tree, arr) {
      tree.forEach(i => {
        const num = arr.findIndex(item => item == i.id);
        i.disabled = num != -1 ? true : false;
        i.children && this.traverseTree(i.children, arr);
      });
      return tree;
    },
    traverseTree2(tree) {
      tree.forEach(i => {
        i.disabled = true;
        i.children && this.traverseTree2(i.children);
      });
      return tree;
    },
    traverseTree3(tree) {
      tree.forEach(i => {
        i.disabled = false;
        i.children && this.traverseTree3(i.children);
      });
      return tree;
    }
  }
};